<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="padding:0px;width:100%;">
      <div style="width:240px;float: left;" class="whiteBox searchbox">
        <h4><i class="el-icon-d-arrow-right"></i> 筛选条件</h4>
        <div class="filter-container search-box">
          <el-form label-position="top" label-width="80px">
            <el-form-item label="搜索">
              <el-input
                size="mini"
                style="width:180px"
                placeholder="姓名或手机号"
                v-model="searchQuery.key"
              ></el-input>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="searchQuery.dateRange1"
                type="daterange"
                size="mini"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="线索来源">
              <el-select
                size="mini"
                style="width:180px;"
                v-model="searchQuery.fromType"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option label="线上" :value="1"></el-option>
                <el-option label="线下" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线下来源" v-if="searchQuery.fromType == 2">
              <el-select
                size="mini"
                style="width:180px;"
                v-model="searchQuery.fromSources"
                @change="fromSourceChange"
                ref="subject"
              >
                <el-option
                  v-for="item in fromSourceOptions"
                  :key="item.dataValue + 'h'"
                  :label="item.dataDisplay"
                  :value="item.dataValue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线上来源" v-if="searchQuery.fromType == 1">
              <el-select
                size="mini"
                style="width:180px;"
                multiple
                v-model="searchQuery.onlineSource"
              >
                <el-option
                  v-for="item in importSourceOptions"
                  :key="item.dataName + 'l'"
                  :label="item.dataDisplay"
                  :value="item.dataName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户经理" v-if="members.length > 1">
              <el-select
                size="mini"
                style="width:180px;"
                multiple
                v-model="searchQuery.member"
              >
                <el-option
                  v-for="item in members"
                  :key="item.memberId"
                  :label="item.userName"
                  :value="item.memberId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="购车类型">
              <el-select
                size="mini"
                style="width:180px;"
                multiple
                v-model="searchQuery.businessTypes"
              >
                <el-option
                  v-for="item in businessTypeOptions"
                  :key="item.dataValue + 'g'"
                  :label="item.dataDisplay"
                  :value="item.dataValue"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="转他店交付">
              <el-select size="mini"
                         style="width:180px;"
                         v-model="searchQuery.isOther">
                <el-option label="全部"
                           :value="0"></el-option>
                <el-option label="是"
                           :value="1"></el-option>
                <el-option label="否"
                           :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="锐见报表统计">
              <el-select size="mini"
                         style="width:180px;"
                         v-model="searchQuery.isReport">
                <el-option label="全部"
                           :value="0"></el-option>
                <el-option label="是"
                           :value="1"></el-option>
                <el-option label="否"
                           :value="2"></el-option>
              </el-select>
            </el-form-item> -->
          </el-form>
          <div style="margin-top:20px;">
            <el-button
              size="small"
              icon="el-icon-search"
              class="filter-item"
              @click="retrieveTables"
              >筛选</el-button
            >
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="filter-item"
              @click="reset"
              >重置</el-button
            >
          </div>
        </div>
      </div>
      <div
        style="margin-left: 220px; overflow:auto;margin-right:20px;padding:0px 20px;"
      >
        <h1 class="page_title">订单审核</h1>
        <div class="filter-container">
          <div style="margin-bottom: 10px;">
            <el-radio-group
              size="small"
              v-model="searchQuery.isDone"
              @change="retrieveTables"
            >
              <el-radio-button :label="false"
                >待审核({{ count0 }})</el-radio-button
              >
              <el-radio-button :label="true">完成</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <el-table :data="tableRecords" stripe v-loading="listLoading">
          <el-table-column align="left" label="创建时间" width="130">
            <template slot-scope="scope">{{
              scope.row.createdAt | parseTime("{y}-{m}-{d} {h}:{i}")
            }}</template>
          </el-table-column>
          <el-table-column align="left" label="客户姓名" width="160">
            <template slot-scope="scope">
              <span class="click_link" @click="toDetailPage(scope.row.id)">
                {{ `${scope.row.customerType === 1 ? scope.row.customerName : scope.row.companyName}${ scope.row.customerPhone ? ` - ` : ''}`  }}
                <Desensitize
                  v-if="scope.row.customerPhone"
                  :text="scope.row.customerPhone"
                  :userType="1"
                  :clearText="true"
                  :queryKey="scope.row.id"
                  :key="scope.row.id"
                />
                </span
              >
              <!-- <span class="click_link"
                    @click="toDetailPage(scope.row.id)">{{scope.row.customerName}}-{{scope.row.customerPhone}}</span> -->
            </template>
          </el-table-column>
          <el-table-column align="left" label="订购车型" min-width="160">
            <template slot-scope="scope">{{ scope.row.modelDisplay }}</template>
          </el-table-column>
          <!-- <el-table-column align="left"
                           label="预计交车时间"
                           width="160">
            <template slot-scope="scope">{{scope.row.deliverDate  | parseTime('{y}-{m}-{d}')}}</template>
          </el-table-column> -->
          <el-table-column align="left" label="客户经理" width="120">
            <template slot-scope="scope">{{ scope.row.ownerName }}</template>
          </el-table-column>
          <el-table-column align="left" label="订金" width="160">
            <template slot-scope="scope">{{ scope.row.paymentDown }}</template>
          </el-table-column>
          <!-- <el-table-column align="left"
                           label="成交金额"
                           width="160">
            <template slot-scope="scope">{{scope.row.paymentDeal}}</template>
          </el-table-column> -->
        </el-table>
        <div class="pagination-container">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="listQuery.page"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.limit"
            layout="total, sizes, prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Desensitize from "@/components/Desensitize/Desensitize.vue";
export default {
  components: {
    Desensitize
  },
  data() {
    return {
      listLoading: false,
      dealer: this.$common.getDealer(),
      user: this.$common.getUser(),
      isAdmin: this.$common.getAdmin(),
      searchQuery: {
        key: "",
        fromType: 0,
        dateRange1: null,
        member: [],
        fromSources: [],
        onlineSource: [],
        businessTypes: [],
        orderStatus: [],
        isOther: 0,
        isReport: 0,
        sortType: 0,
        isDone: false,
      },
      datePickerOption: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      members: [],
      businessTypeOptions: [],
      fromSourceOptions: [],
      importSourceOptions: [],

      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },
      tableRecords: [],
      count0: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let form = from.path;
      if (form === "/approved" || form === "/submitted") {
        try {
          var listFilters = JSON.parse(sessionStorage.getItem("listFilters4"));
          vm.searchQuery = listFilters.searchQuery;
          vm.total = listFilters.total;
          vm.listQuery = listFilters.listQuery;
        } catch (error) {
          console.log(error)
        }
      }
      vm.getList();
      vm.retrieveTotal();
    });
  },
  created() {
    var baseInfo = this.$common.getBaseInfo();
    this.businessTypeOptions = baseInfo.businessTypes;
    this.fromSourceOptions = baseInfo.customerFromSources;
    this.importSourceOptions = baseInfo.importSources;
    this.retrieveMembers();
  },
  methods: {
    retrieveMembers() {
      var parent = this;
      this.$httpAuth
        .post("/v2/appDealerManagerService/memberList", {
          dealerId: this.dealer.dealerId,
        })
        .then(function(response) {
          parent.members = response.data.data;
          if (!parent.isAdmin) {
            parent.members.push({
              memberId: parent.dealer.userId,
              userName: parent.dealer.name,
            });
          }
        });
    },
    retrieveTables() {
      this.listQuery.page = 1;
      if (this.searchQuery.isDone && this.searchQuery.dateRange1 === null) {
        this.searchQuery.dateRange1 = [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6).Format(
            "yyyy-MM-dd"
          ),
          new Date().Format("yyyy-MM-dd"),
        ];
      }
      this.getList();
    },
    getList() {
      var parent = this;
      if (this.searchQuery.fromType == 1) {
        this.searchQuery.fromSources = [];
      } else if (this.searchQuery.fromType == 2) {
        this.searchQuery.onlineSource = [];
      } else {
        this.searchQuery.fromSources = [];
        this.searchQuery.onlineSource = [];
      }
      let params = {
        dealerId: this.dealer.dealerId,
        pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
        pageCount: this.listQuery.limit,
        saleIds:
          this.searchQuery.member.length > 0
            ? this.searchQuery.member.join(",")
            : "",
        createdDate: {
          start:
            this.searchQuery.dateRange1 != null
              ? this.searchQuery.dateRange1[0]
              : "",
          end:
            this.searchQuery.dateRange1 != null
              ? this.searchQuery.dateRange1[1]
              : "",
        },
        key: this.searchQuery.key,
        fromType: this.searchQuery.fromType,
        fromSources:
          this.searchQuery.fromSources.length > 0
            ? this.searchQuery.fromSources.join(",")
            : "",
        onlineSources:
          this.searchQuery.onlineSource.length > 0
            ? this.searchQuery.onlineSource.join(",")
            : "",
        businessTypes:
          this.searchQuery.businessTypes.length > 0
            ? this.searchQuery.businessTypes.join(",")
            : "",
        orderStatus:
          this.searchQuery.orderStatus.length > 0
            ? this.searchQuery.orderStatus.join(",")
            : "",
        isOther: this.searchQuery.isOther,
        isReport: this.searchQuery.isReport,
        sortType: this.searchQuery.sortType,
        isDone: this.searchQuery.isDone,
        orderType: 1,
      };
      this.listLoading = true;
      this.$httpAuth
        .post("/v2/appVerifyService/orderList", params)
        .then(function(response) {
          parent.listLoading = false;
          parent.tableRecords = response.data.data;
          parent.total = response.data.total;
        })
        .catch(() => {
          parent.listLoading = false;
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    reset() {
      this.searchQuery = {
        key: "",
        fromType: 0,
        dateRange1: null,
        member: [],
        fromSources: [],
        onlineSource: [],
        businessTypes: [],
        orderStatus: [],
        isOther: 0,
        isReport: 0,
        sortType: 0,
        isDone: false,
      };
      this.retrieveTables();
      this.retrieveTotal();
    },
    toDetailPage(id) {
      sessionStorage.setItem("form", "");
      var listFilters = {
        searchQuery: this.searchQuery,
        sortType: this.sortType,
        total: this.total,
        listQuery: this.listQuery,
      };
      sessionStorage.setItem("listFilters4", JSON.stringify(listFilters));
      if (!this.searchQuery.isDone) {
        // 待审核
        this.$router.push({ path: "/submitted", query: { id: id, type: 1 } });
      } else {
        // 已完成
        this.$router.push({ path: "/approved", query: { id: id } });
      }
    },
    retrieveTotal() {
      this.getActivityTotal(1, "count0");
    },
    getActivityTotal(filterType, column) {
      var parent = this;
      if (this.searchQuery.fromType == 1) {
        this.searchQuery.fromSources = [];
      } else if (this.searchQuery.fromType == 2) {
        this.searchQuery.onlineSource = [];
      } else {
        this.searchQuery.fromSources = [];
        this.searchQuery.onlineSource = [];
      }
      let params = {
        dealerId: this.dealer.dealerId,
        pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
        pageCount: this.listQuery.limit,
        saleIds:
          this.searchQuery.member.length > 0
            ? this.searchQuery.member.join(",")
            : "",
        createdDate: {
          start:
            this.searchQuery.dateRange1 != null
              ? this.searchQuery.dateRange1[0]
              : "",
          end:
            this.searchQuery.dateRange1 != null
              ? this.searchQuery.dateRange1[1]
              : "",
        },
        key: this.searchQuery.key,
        fromType: this.searchQuery.fromType,
        fromSources:
          this.searchQuery.fromSources.length > 0
            ? this.searchQuery.fromSources.join(",")
            : "",
        onlineSources:
          this.searchQuery.onlineSource.length > 0
            ? this.searchQuery.onlineSource.join(",")
            : "",
        businessTypes:
          this.searchQuery.businessTypes.length > 0
            ? this.searchQuery.businessTypes.join(",")
            : "",
        orderStatus:
          this.searchQuery.orderStatus.length > 0
            ? this.searchQuery.orderStatus.join(",")
            : "",
        isOther: this.searchQuery.isOther,
        isReport: this.searchQuery.isReport,
        sortType: this.searchQuery.sortType,
        isDone: false,
        orderType: 1,
      };
      this.$httpAuth
        .post("/v2/appVerifyService/orderList", params)
        .then(function(res) {
          parent[column] = res.data.total
          // if (column != "") {
          //   // eval("parent." + column + "= response.data.total");
          // }
        });
    },
  },
};
</script>

<style>
.el-pagination .more + .number {
  display: none !important;
}
</style>
